import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.services-slider' ).length ) {
        $( '.services-slider' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '16px',
            perPage: 3,
            perMove: 1,
            focus: 'left',
            pagination: false,
            speed: 800,
            breakpoints: {
              1269: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } ).on( 'setPosition', function( event, slick ) {
            // set all slides to height of tallest slide
            slick.$slides.css( 'height', slick.$slideTrack.height() + 'px' );
          } );

          const applyOverflowState = ( isOverflow ) => {
            const root = splide.root;

            if ( !isOverflow ) {
              // Go static
              splide.options = {type: 'slide', arrows: false, drag: false};
              root.classList.add( 'is-static' );
            } else {
              // Re-activate slider
              splide.options = {type: 'loop', arrows: true, drag: true};
              root.classList.remove( 'is-static' );
            }
          };

          // Fires on mount/refresh when Splide recalculates layout
          splide.on( 'overflow', applyOverflowState );

          // Debounced refresh so we don't thrash on continuous resize
          let rafId;
          const refresh = () => {
            if ( rafId ) cancelAnimationFrame( rafId );
            rafId = requestAnimationFrame( () => splide.refresh() );
          };

          // Splide emits 'resize' itself; also handle 'updated'
          splide.on( 'resize', refresh );
          splide.on( 'updated', refresh );

          // Also listen for CSS breakpoint crossings (helps some layouts)
          [window.matchMedia( '(max-width: 1024px)' ),
            window.matchMedia( '(max-width: 768px)' )].forEach( ( mq ) => {
            mq.addEventListener( 'change', refresh );
          } );

          splide.mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'services-slider', COMPONENT );
} )( app );
